module.exports = __webpack_public_path__ + "img/topindicator8.4de992dd.png";